import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import { createWorkflowExtension } from '@spotify/plugin-confidence-workflows-react';

import { AbTestTableRow } from './components';
import { AbTestIcon } from './components/AbTestIcon';
import { ABTEST_CHANGE_EXTENSION } from './components/AbTestInstanceUpdates/AbTestChangeExtension';
import { FLAGS_CHANGE_EXTENSION } from './components/AbTestInstanceUpdates/FlagsModuleDataChangeExtension';
import { METRICS_CHANGE_EXTENSION } from './components/AbTestInstanceUpdates/MetricsChangeExtension';
import { PLANNING_CHANGE_EXTENSION } from './components/AbTestInstanceUpdates/PlanningChangeExtension';
import { REPORT_CHANGE_EXTENSION } from './components/AbTestInstanceUpdates/ReportChangeExtension';
import { AB_TEST_WORKFLOW_ID } from './constants';

export const confidenceWorkflowsModuleAbTestPlugin = createPlugin({
  id: 'confidence-workflows-module-ab-test',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-ab-test-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const AbTestWorkflowPage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowPage),
  loadOptions,
);
const AbTestWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowInstancePage),
  loadOptions,
);
const CreateAbTest = loadable(
  () => componentsChunk().then(m => m.CreateAbTest),
  loadOptions,
);
const AbTestOpenGraph = loadable(
  () => componentsChunk().then(m => m.AbTestOpenGraph),
  loadOptions,
);

export const ABTestWorkflowExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(
    createWorkflowExtension({
      title: 'A/B test',
      workflowId: AB_TEST_WORKFLOW_ID,
      workflowPage: () => <AbTestWorkflowPage />,
      workflowInstancePage: () => <AbTestWorkflowInstancePage />,
      workflowTableRowComponent: AbTestTableRow,
      workflowIcon: AbTestIcon,
      createComponent: overrides => <CreateAbTest overrides={overrides} />,
      openGraphComponent(name) {
        return <AbTestOpenGraph name={name} />;
      },
    }),
  );

// Change extensions

export const AbTestChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(ABTEST_CHANGE_EXTENSION);

export const PlanningChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(PLANNING_CHANGE_EXTENSION);

export const MetricsChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(METRICS_CHANGE_EXTENSION);

export const ReportChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(REPORT_CHANGE_EXTENSION);

export const FlagsModuleDataChangeExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(FLAGS_CHANGE_EXTENSION);
